import {
    useSelectAlwaysShowMenuBar,
    useSelectAppSettings,
} from 'app/store/appSettings/selectors';
import { useSelectIsAppToolbarHidden } from './appSettings/selectors';
import {
    useSelectCurrency,
    selectCurrency,
} from 'app/currencies/store/selectors';
import State from 'store/State';
import { selectAppSettings } from './appSettings/selectors';
import { useSelector } from 'react-redux';

// These should match CSS properties...
const TOOLBAR_HEIGHT = 33; // $toolbar-height
const TOOLBAR_TOGGLE_SHOWN_PANEL_HEIGHT = 12; // $toggle-shown-panel-height
const TOOLBAR_HIDDEN_BORDER_HEIGHT = 1; // $hidden-border-height
const APP_TOOLBAR_HEIGHT_WHEN_SHOWN_AND_COLLAPSABLE =
    TOOLBAR_HEIGHT + TOOLBAR_TOGGLE_SHOWN_PANEL_HEIGHT;
const APP_TOOLBAR_HEIGHT_WHEN_SHOWN_AND_NOT_COLLAPSABLE = TOOLBAR_HEIGHT;
const APP_TOOLBAR_HEIGHT_WHEN_HIDDEN =
    TOOLBAR_TOGGLE_SHOWN_PANEL_HEIGHT + TOOLBAR_HIDDEN_BORDER_HEIGHT;

export const selectAppState = (state: State) => state.app;

export const useSelectToolbarHeight = () => {
    const alwaysShowMenuBar = useSelectAlwaysShowMenuBar();
    const isAppToolbarHidden = useSelectIsAppToolbarHidden();

    if (alwaysShowMenuBar) {
        return APP_TOOLBAR_HEIGHT_WHEN_SHOWN_AND_NOT_COLLAPSABLE;
    }

    return isAppToolbarHidden
        ? APP_TOOLBAR_HEIGHT_WHEN_HIDDEN
        : APP_TOOLBAR_HEIGHT_WHEN_SHOWN_AND_COLLAPSABLE;
};

export const selectAppCurrency = (state: State) => {
    const appSettings = selectAppSettings(state);
    return selectCurrency(state, appSettings.currencyCode);
};

export const useAppCurrency = () => useSelector(selectAppCurrency);

export const useSelectCurrentCurrency = () => {
    const appSettings = useSelectAppSettings();
    return useSelectCurrency(appSettings.currencyCode);
};
